// src/database/client.ts
import { createClient, Client } from "@libsql/client";

type SafeClient = Client | { execute: (...args: any[]) => Promise<any> };

const url = import.meta.env.VITE_TURSO_DATABASE_URL as string | undefined;
const authToken = import.meta.env.VITE_TURSO_AUTH_TOKEN as string | undefined;

console.log('[Turso Client] URL present:', !!url);
console.log('[Turso Client] Token present:', !!authToken);

let turso: SafeClient;

if (!url || !authToken) {
  console.warn(
    "[Turso Client] Env vars missing - using localStorage-only mode. " +
    "Database features will be limited."
  );

  // Fallback client that doesn't crash the app
  turso = {
    async execute(...args: any[]) {
      console.warn("[Turso Client] No-op execute called (localStorage mode):", args);
      return { rows: [] };
    },
  };
} else {
  // Normal DB client with real Turso credentials
  console.log('[Turso Client] Initializing with credentials');
  turso = createClient({
    url,
    authToken,
  });
}

export { turso };
export default turso;
